(() => {
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[data-whatsapp-number]');
    if (!link) return;
    const phone = link.dataset.whatsappNumber.replace(/\D/g, '');
    if (!/^[1-9]\d{7,14}$/.test(phone)) { event.preventDefault(); return; }
    const form = document.getElementById(link.dataset.productForm);
    const variantId = form?.querySelector('[name="id"]')?.value;
    const quantityInput = document.querySelector(`input[name="quantity"][form="${CSS.escape(link.dataset.productForm)}"]`);
    const quantity = quantityInput?.value || form?.querySelector('[name="quantity"]')?.value || '1';
    let variants = [];
    try { variants = JSON.parse(link.dataset.variants || '[]'); } catch { /* Basic product link remains usable. */ }
    const variant = variants.find(item => String(item.id) === variantId);
    const options = variant && variant.title !== 'Default Title' ? ` (${variant.title})` : '';
    const url = new URL(link.dataset.productUrl);
    if (variantId) url.searchParams.set('variant', variantId);
    let price = '';
    if (variant && Number.isFinite(Number(variant.price)) && link.dataset.currency) {
      try { price = new Intl.NumberFormat('en', {style: 'currency', currency: link.dataset.currency}).format(Number(variant.price) / 100); } catch { /* Product URL remains available if currency formatting fails. */ }
    }
    const message = `Hello, I would like to order ${link.dataset.productTitle}${options}.\nQuantity: ${quantity}.${price ? `\nPrice: ${price} each.` : ''}\n${url.href}`;
    link.href = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
  });
  const initializeVideos = () => {
    document.querySelectorAll('[data-vhome-banner-video]').forEach(video => {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        video.removeAttribute('autoplay'); video.pause();
      } else { video.play().catch(() => {}); }
    });
  };
  initializeVideos();
  document.addEventListener('shopify:section:load', initializeVideos);
  const initializeSearchHints = () => {
    document.querySelectorAll('[data-vhome-search-hints]').forEach(input => {
      if (input.dataset.hintsReady) return;
      input.dataset.hintsReady = 'true';
      const phrases = ['Kitchen Essentials', 'Bathroom Essentials', 'Storage Solutions', 'Home Essentials', 'Everyday Finds'];
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let phrase = 0, length = 0, deleting = false;
      const tick = () => {
        if (!input.isConnected) return;
        if (reducedMotion.matches) { input.placeholder = 'Search for home essentials'; return; }
        if (document.activeElement === input || input.value || document.hidden) { setTimeout(tick, 500); return; }
        const text = phrases[phrase];
        length += deleting ? -1 : 1;
        input.placeholder = 'Looking for ' + text.slice(0, length) + '…';
        let delay = deleting ? 40 : 85;
        if (!deleting && length >= text.length) { deleting = true; delay = 1800; }
        else if (deleting && length <= 0) { deleting = false; phrase = (phrase + 1) % phrases.length; delay = 300; }
        setTimeout(tick, delay);
      };
      input.addEventListener('focus', () => { input.placeholder = 'Search for products'; });
      tick();
    });
  };
  initializeSearchHints();
  document.addEventListener('shopify:section:load', initializeSearchHints);
})();
